/**
 * Ankerziel beim Laden: Kommt man von einer Unterseite über /#kontakt, springt der Browser oft zu früh (Schriften und
 * Elementor-Layout stehen noch nicht) oder gar nicht. Nach dem Laden der Schriften einmal sofort (ohne Animation) zum
 * Ziel springen; scroll-margin-top im CSS hält es unter dem fixen Header frei.
 */
export function init() {
	const id = decodeURIComponent(window.location.hash.slice(1));
	const target = id && document.getElementById(id);
	if (!target) return;

	const go = () => target.scrollIntoView({ behavior: 'instant', block: 'start' });
	(document.fonts?.ready || Promise.resolve()).then(go);
}
